import {blue, green, orange} from "@mui/material/colors";
import {
    GatewayNumberDto,
    GatewayNumberType,
    SmsCampaignRecordDeliveryStatus,
    SmsCampaignStatus,
} from "../../../api/psc";
import {SmsCampaignType} from "../smsCampaignSlice/SmsCampaignSlice";

export interface SmsCampaignStatusInfo {
    text: string;
    color: string;
}

export interface SmsCampaignRecordStatusInfo {
    text: string;
    color: string;
}

export const GetSmsCampaignTypesList = [
    {
        title: "ارسال به سازندگان پروژه ها",
        description: "بر مبنای فیلتر پروژه ها به سازندگان پیامک ارسال کنید",
        type: SmsCampaignType.CampaignWithProjectFilter,
        icon: "people",
        color: blue[600],
    },
    {
        title: "ارسال به شماره های فایل اکسل",
        description: "به فایل اکسل شامل شماره اشخاص مورد نظر پیامک ارسال کنید",
        type: SmsCampaignType.CampaignWithExcelFile,
        icon: "contact_page",
        color: green[600],
    },
    {
        title: "ارسال آزمایشی به شماره های دلخواه",
        description:
            "به منظور تست کمپین برای شماره های انتخابی پیامک ارسال کنید",
        type: SmsCampaignType.CampaignWithTestMobileNumbers,
        icon: "science",
        color: orange[700],
    },
];

export const smsCampaignAvailableHours = [
    {
        hour: 8,
        addition: 0,
        timeOfDateLabel: "صبح",
    },
    {
        hour: 9,
        addition: 0,
        timeOfDateLabel: "صبح",
    },
    {
        hour: 10,
        addition: 0,
        timeOfDateLabel: "صبح",
    },
    {
        hour: 11,
        addition: 0,
        timeOfDateLabel: "صبح",
    },
    {
        hour: 12,
        addition: 0,
        timeOfDateLabel: "ظهر",
    },
    {
        hour: 1,
        addition: 12,
        timeOfDateLabel: "بعد از ظهر",
    },
    {
        hour: 2,
        addition: 12,
        timeOfDateLabel: "بعد از ظهر",
    },
    {
        hour: 3,
        addition: 12,
        timeOfDateLabel: "بعد از ظهر",
    },
    {
        hour: 4,
        addition: 12,
        timeOfDateLabel: "بعد از ظهر",
    },
    {
        hour: 5,
        addition: 12,
        timeOfDateLabel: "بعد از ظهر",
    },
    {
        hour: 6,
        addition: 12,
        timeOfDateLabel: "بعد از ظهر",
    },
    {
        hour: 7,
        addition: 12,
        timeOfDateLabel: "بعد از ظهر",
    },
    {
        hour: 8,
        addition: 12,
        timeOfDateLabel: "بعد از ظهر",
    },
];

export function GetLabelForGatewayNumber(gatewayNumber: GatewayNumberDto): {
    title: string;
    color: string;
} {
    switch (gatewayNumber.type) {
        case GatewayNumberType.TEST:
            return {title: "تست", color: "#9c4643"};
        case GatewayNumberType.TYPE1000:
            return {title: "سرشماره ۱۰۰۰", color: "#26944b"};
        case GatewayNumberType.TYPE2000:
            return {title: "سرشماره ۲۰۰۰", color: "#265094"};
        case GatewayNumberType.TYPE3000:
            return {title: "سرشماره ۳۰۰۰", color: "#1e6e68"};
    }
}

export function ParseSmsCampaignStatus(
    status: SmsCampaignStatus
): SmsCampaignStatusInfo {
    switch (status) {
        case SmsCampaignStatus.WAITING_FOR_EXECUTION:
            return {text: "در انتظار", color: "#ff9729"};
        case SmsCampaignStatus.EXECUTED:
            return {text: "ارسال شده", color: "#00875a"};
        case SmsCampaignStatus.FINISHED:
            return {text: "پایان یافته", color: "#007cb5"};
        case SmsCampaignStatus.WAITING_FOR_ADMIN_REVIEW:
            return {text: "در انتظار بررسی", color: "#b0600b"};
        case SmsCampaignStatus.ADMIN_REJECTED:
            return {text: "رد شده توسط ادمین", color: "#ad2626"};
    }
}

export function ParseSmsCampaignRecordStatus(
    status: SmsCampaignRecordDeliveryStatus
): SmsCampaignRecordStatusInfo {
    switch (status) {
        case SmsCampaignRecordDeliveryStatus.PENDING:
            return {text: "در انتظار", color: "#bf8d0d"};
        case SmsCampaignRecordDeliveryStatus.DELIVERED:
            return {text: "دلیور شده", color: "#18702f"};
        case SmsCampaignRecordDeliveryStatus.BLACK_LIST:
            return {text: "بلک لیست", color: "#381f1a"};
        case SmsCampaignRecordDeliveryStatus.CHECK_OK:
            return {text: "ارسال شده به اپراتور", color: "#156955"};
        case SmsCampaignRecordDeliveryStatus.ERROR:
            return {text: "خطا", color: "#9c1a1a"};
        case SmsCampaignRecordDeliveryStatus.NOT_SENT:
            return {text: "عدم ارسال", color: "#9c1a1a"};
        case SmsCampaignRecordDeliveryStatus.RATE_LIMITED:
            return {text: "محدودیت ارسال", color: "#9c1a1a"};
    }
}
